/**
 * Admin-notification row enums shared by the data layer, the header bell and
 * the Notifications screen. Values mirror the CHECK constraints in
 * clockout-service sql/V10__admin_notifications.sql (KAN-509).
 */
export const NOTIFICATION_TYPE = Object.freeze({
    ADVANCE_FAILED: 'advance_failed',
    SETTLEMENT_FAILED: 'settlement_failed',
    TROUBLE_TICKET_CREATED: 'trouble_ticket_created',
    SUPPORT_TICKET_STATUS_CHANGED: 'support_ticket_status_changed',
});

export const NOTIFICATION_SEVERITY = Object.freeze({
    ERROR: 'error',
    WARNING: 'warning',
    INFO: 'info',
});

export const NOTIFICATION_RESOURCE_TYPE = Object.freeze({
    ADVANCE_LIFECYCLE: 'advance_lifecycle',
    PENDING_SETTLEMENT: 'pending_settlement',
    TROUBLE_TICKET: 'trouble_ticket',
    SUPPORT_TICKET: 'support_ticket',
});
